module.exports = __webpack_public_path__ + "sounds/5742b94500f826553a96c607d1b6b486.mp3";


//////////////////
// WEBPACK FOOTER
// ./common/assets/sounds/music.mp3
// module id = 95
// module chunks = 0